import { pathname } from '../../../../utils';

export function getTotalOnboadingSteps(mobile: boolean) {
  let onboardingPages = Object.values(pathname.onboarding.main);
  onboardingPages = onboardingPages.filter((page) => page.stepInStepper);
  if (mobile) {
    return onboardingPages.length;
  } else {
    const desktopPages = onboardingPages.filter((page) => !page['mobile']);
    return desktopPages.length;
  }
}
